<template>
  <div class="container-cap" id="establishments-o4-results" v-if="surveillance">
    <div class="row">
      <div class="col-xs-12">
        <h2>
          Résultats <span class="label label-observa4">OBSERVA4</span>
          <div v-if="dataset != null">
            <p>
              <small>
                Pour les fiches issues des Données «{{ dataset }}»
              </small>
            </p>
            <dropdown tag="span">
              <btn type="primary" class="dropdown-toggle" role="button"
                   size="sm"
                   id="finess-list">
                Changer &nbsp;&nbsp;
                <span class="caret"></span>
              </btn>
              <template slot="dropdown">
                <li v-if="datasets.spiadi">
                  <a role="button"
                     @click="dataset = datasets.spiadi"
                     :disabled="dataset === datasets.spiadi">
                    {{ datasets.spiadi }}
                  </a>
                </li>
                <li v-for="(c, k) in datasets.others"
                    :key="`change-carac-${k}`">
                  <a role="button"
                     @click="dataset = c"
                     :disabled="dataset === c">
                    {{ c }}
                  </a>
                </li>
              </template>
            </dropdown>
          </div>
        </h2>
        <hr>
        <div v-if="!hasAccess">
          <div class="col-lg-9 col-xs-12">
            <alert type="warning" class="text-justify">
              <h4>
                Accès non autorisé aux résultats de l'établissement
                «{{ surveillance.establishment.name }}»
              </h4>
              <p>
                Pour des raisons de confidentialité (CNIL), les résultats
                {{ surveillance.year }} sont, par défaut, uniquement accessibles
                au responsable du programme.
              </p>
              <p>
                <strong>
                  Pour obtenir vos résultats, merci de bien vouloir contacter le
                  responsable du programme (personne ayant effectué
                  l'inscription) pour votre établissement :
                  {{ surveillance.registrator.firstName }} {{ surveillance.registrator.name }}.
                </strong>
              </p>
              <p>
                N'hésitez pas à revenir vers nous via le
                <router-link to="/contact">formulaire de contact</router-link> si
                vous souhaitez avoir plus de précisions.
              </p>
            </alert>
          </div>
        </div>
        <div v-else-if="dataset == null">
          <div v-if="['2022', '2021', '2023', '2024', '2025', '2026'].indexOf(year) !== -1">
            <alert type="warning">
              <p class="text-justify">
                <strong>
                  Merci de sélectionner les données pour lesquelles vous
                  souhaitez obtenir vos résultats.
                </strong>
              </p>
            </alert>
            <div>
              <h3>Vos données envoyées au programme national</h3>
              <div class="row">
                <div class="col-xs-6 col-md-4 col-lg-3 open-button-container">
                  <btn class="open-button btn-results"
                       block
                       @click="dataset = datasets.spiadi">
                    <strong>{{ datasets.spiadi }}</strong>
                  </btn>
                </div>
              </div>
            </div>
            <div v-if="datasets.others.length > 0">
              <h3>Vos données personnalisées</h3>
              <div class="row" >
                <div v-for="(c, k) in datasets.others"
                     class="col-xs-6 col-md-4 col-lg-3 open-button-container"
                     :key="`nav-carac-${k}`">
                  <btn class="open-button btn-results"
                       block
                       @click="dataset = c">
                    <strong>{{ c }}</strong>
                  </btn>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <alert type="warning" class="col-lg-9">
              <p class="text-justify">
                <strong>
                  Le module résultat est en cours d'adaptation aux protocoles
                  {{year}}.
                </strong>
              </p>
            </alert>
          </div>
        </div>
        <div v-else>
          <div v-if="currentDataset != null && currentDataset.step === 1"
               class="results">
            <div class="row">
              <div class="col-xs-12">
                <h2>Participation</h2>
                <alert type="warning" v-if="spiadi">
                  <p>
                    <strong>
                      Merci pour votre participation au volet
                      <span class="label label-observa4">OBSERVA4</span> du
                      programme SPIADI{{ year }} !
                    </strong>
                  </p>
                </alert>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-5 col-lg-5 chart-container">
                <chart type="pie-chart" :config="sheetsByTypes.config"
                       :exportConfig="sheetsByDiscipline.exportConfig"></chart>
              </div>
              <div class="col-xs-12 col-md-5 col-lg-5 chart-container">
                <chart type="pie-chart" :config="sheetsByDiscipline.config"
                       :exportConfig="sheetsByDiscipline.exportConfig"></chart>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <hr>
                <h2>Statistiques</h2>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12" v-if="sheets != null">
                <sui-filter-input v-model="filteredSheets"
                                  :list="sheets"
                                  :variables="filterVariables">
                  <p>
                    Le champ texte ci-dessous vous permet de filtrer les fiches
                    prises en compte dans le calcul des résultats. Tout sera
                    immédiatement recalculé en tenant compte du
                    filtre choisit, vous permettant d'explorer les données en
                    profondeur.
                  </p>
                </sui-filter-input>
              </div>
            </div>

            <div class="col-xs-12" v-if="sheets != null">
              <sui-observa4-results :title="title" :distribution="distribution"
                                    :year="parseInt(year)">
              </sui-observa4-results>
            </div>
          </div>
          <div v-else>
            <alert type="warning">
              <p>
                <strong>
                  Sur cette page apparaîtront les résultats «{{dataset}}» dès
                  lors que la modalité
                  <span class="label label-observa4">OBSERVA4</span> sera
                  validée.
                </strong>
              </p>
              <p>
                Pour cela, rendez-vous sur l'accueil de la modalité et utilisez
                le bouton «{{dataset}}» pour :
                <ul>
                  <li>choisir la période des observations,</li>
                  <li>valider et envoyer les fiches.</li>
                </ul>
              </p>
            </alert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import modules from '@/sui/data/modules'
import distribution from '@/sui/data/distribution'
import chart from '@/sui/components/charts/chart'
import { mapGetters } from 'vuex'
import suiObserva4Results from '@/sui/components/results/observa4'
import caracteristics from '@/sui/data/caracteristics'
import sc from '@/sui/sc/sheetCaracteristics'
import suiFilterInput from '@/sui/components/dataFilterInput'

export default {
  name: 'establishment-o4-results',

  data: function () {
    return {
      isMounted: false,
      dataset: null,
      sheets: null,
      filteredSheets: { filter: '', list: [] }
    }
  },

  computed: {
    ...mapGetters({
      userId: 'user/id',
      get: 'surveillances/get'
    }),

    filterVariables: function () {
      return sc.filterVariables.observa4(this.year)
    },

    surveillance: function () {
      return this.get(this.year, this.$route.params.id)
    },

    title: function () {
      if (this.surveillance == null) {
        return ''
      }

      const e = this.surveillance.establishment.name
      return `${this.dataset} - ${e}`
    },

    referenceSheets: function () {
      if (this.sheets == null) {
        return null
      }

      if (this.filteredSheets === '') {
        return this.sheets
      }

      return this.filteredSheets.list
    },

    distribution: function () {
      if (this.referenceSheets == null) {
        return null
      }

      try {
        const dist = distribution('observa4', this.referenceSheets, this.year)

        return dist
      } catch (e) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
        })
      }
      return null
    },

    sheetsByTypes: function () {
      const base = '#0a77a7'
      const alphaBase = `${base}84`
      const result = {
        options: {
          title: {
            display: true,
            fontColor: base,
            fontSize: 14,
            text: 'Chargement...'
          },
          cutoutPercentage: 50,
          legend: {
            position: 'bottom',
            labels: {
              fontColor: base
            }
          },

          plugins: {
            datalabels: {
              backgroundColor: 'white',
              borderRadius: 3,
              borderColor: alphaBase,
              color: base,
              font: {
                weight: 'bold'
              },
              display: function (context) {
                const index = context.dataIndex
                const value = context.dataset.data[index]
                return value > 0
              },
              offset: 0
            }
          }
        },
        data: {}
      }

      if (!this.isMounted || this.distribution == null) {
        result.data.labels = [ 'Chargement...' ]
        result.data.datasets = [
          {
            fill: true,
            backgroundColor: [
              '#cccccc',
              '#cccccc44'
            ],
            data: [ 5, 1 ]
          }
        ]
        return {
          exportConfig: [],
          config: result
        }
      }
      return caracteristics.toPlot.rep(
        this.distribution.obsManagment,
        {
          f: 'obsManagment',
          t: 'Répartition des fiches par type',
          v: [
            {
              code: 1,
              value: 'P1 - Pose d’un cathéter central ou d’un MID-PI'
            },
            {
              code: 2,
              value: `P2 - Pose d’un CVP ou d’un MID sans PI`
            },
            {
              code: 3,
              value: `P3 - Pose d’un aiguille sur CCI`
            },
            {
              code: 6,
              value: `P4 - Pose d'un cathéter sous-cutané`
            },
            {
              code: 4,
              value: `B1 - Manipulation distale`
            },
            {
              code: 5,
              value: `B2 - Manipulation proximale sur cathéter central ou MID-PI`
            },
            {
              code: 7,
              value: `R1 - Réfection de pansement d'un cathéter central`
            }
          ]
        }
      ).doughnut()
    },

    sheetsByDiscipline: function () {
      if (this.distribution == null) {
        const base = '#0a77a7'
        const alphaBase = `${base}84`
        return {
          config: {
            options: {
              title: {
                display: true,
                fontColor: base,
                fontSize: 14,
                text: 'Chargement...'
              },
              cutoutPercentage: 50,
              legend: {
                position: 'bottom',
                labels: {
                  fontColor: base
                }
              },

              plugins: {
                datalabels: {
                  backgroundColor: 'white',
                  borderRadius: 3,
                  borderColor: alphaBase,
                  color: base,
                  font: {
                    weight: 'bold'
                  },
                  display: function (context) {
                    const index = context.dataIndex
                    const value = context.dataset.data[index]
                    return value > 0
                  },
                  offset: 0
                }
              }
            },
            data: {}
          },
          exportConfig: []
        }
      }

      return caracteristics.toPlot.rep(
        this.distribution.discipline,
        caracteristics.cfg.discipline
      ).doughnut()
    },

    isRegistrator: function () {
      if (this.surveillance == null) {
        return false
      }

      return this.surveillance.isRegistrator(this.userId)
    },

    hasAccess: function () {
      return this.isRegistrator || this.canGetResults
    },

    canGetResults: function () {
      if (this.surveillance == null) {
        return false
      }

      return this.surveillance.canGetStatistics(this.userId, 'observa4')
    },

    spiadi: function () {
      return this.year === '2021' && this.datasets.spiadi === this.dataset
    },

    moduleColor: function () {
      return modules[this.year].observa4.color
    },

    currentDataset: function () {
      if (this.dataset == null) {
        return null
      }

      return this.currentModule.dset.find(
        d => d.name === this.dataset
      )
    },

    currentModule: function () {
      return this.surveillance.modules.observa4
    },

    datasets: function () {
      const result = {
        spiadi: `SPIADI${this.year}`,
        others: new Set()
      }
      if (this.surveillance == null) {
        return result
      }

      const mc = this.currentModule
      if (mc == null || mc.dset == null) {
        return result
      }

      mc.dset.forEach(
        d => {
          if (d.step < 1) {
            return
          }

          if (!d.name.toLowerCase().includes('spiadi')) {
            result.others.add(d.name)
          }
        }
      )

      result.others = Array.from(result.others)

      return result
    },

    year: function () {
      return this.$route.params.year
    }
  },

  mounted: function () {
    if (this.surveillance != null && this.dataset != null) {
      this.fill()
    }
    this.isMounted = true
  },

  watch: {
    surveillance: function () {
      if (this.dataset != null) {
        this.fill()
      }
    },

    dataset: function () {
      this.fill()
    }
  },

  methods: {
    fill: function () {
      const vm = this
      const arg = {
        mod: 'observa4',
        surv: vm.surveillance.id,
        name: this.dataset,
        year: vm.surveillance.year
      }

      vm.$store.dispatch('surveillances/getDatasetSheets', arg).then(
        (res) => {
          if (res.data.err == null) {
            this.sheets = res.data.v
          } else {
          }
          return res
        }
      ).catch(
        e => {

        }
      )
    }
  },

  components: {
    chart,
    'sui-observa4-results': suiObserva4Results,
    'sui-filter-input': suiFilterInput
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#establishments-o4-results {
  margin-bottom: 2rem;
  .results {
    h2:first-child {
      margin-top: 0rem;
    }
  }
}
</style>
